import lozad from "lozad";
import { header } from "../index/scripts/header";
import { ToggleItem, indicatorSlide, setBackgroundElement } from "../index/scripts/helper";
import Swiper, { Navigation, Pagination } from "swiper";
import { home } from "../index/scripts/home";
$(document).ready(function () {
	header.init();
	setBackgroundElement();
	swiperServiceNews();
	indicatorSlide();
	ToggleItem();
	swiperPortfolio();
	countElementServices();
	home.video();
	CountUpNumber();
	sectionBaseTech();
	initializeContent();
	stickyMenuTop();
});
function stickyMenuTop() {
	const section = $("main section");
	for (var i = 0, length = section.length; i < length; i++) {
		new Waypoint({
			element: section[i],
			handler: function (direction) {
				$(`.sticky-menu-top li:eq(${i})`).addClass("active").siblings().removeClass("active");
			},
			offset: "30%",
		});
	}
}

function sectionBaseTech() {
	$(".section-service-website-design.section-base-technology .btn-view-more").on("click", function () {
		$(this).toggleClass("active");
		if ($(this).hasClass("active")) {
			$(this).text("Thu gọn");
			$(".section-service-detail.section-base-technology .wrap-item-toggle").css("display", "block");
		} else {
			$(".section-service-detail.section-base-technology .wrap-item-toggle").css("display", "");
			$(this).text("Xem thêm");
		}
	});
}
function CountUpNumber() {
	var nodeCount = $(".countup");
	const options = {
		duration: 3,
		separator: ".",
		scrollSpyOnce: true,
		enableScrollSpy: true,
	};
	var nodeAnimation;
	nodeCount.each(function (index) {
		var value = $(nodeCount[index]).data("number");
		nodeAnimation = new countUp.CountUp(nodeCount[index], value, options);
		nodeAnimation.start();
	});
}
function countElementServices() {
	const itemNumber = $(".section-service-detail.section-1 .wrap-item .item").length;
	const parent = $(".section-service-detail.section-1 .wrap-item");
	if (itemNumber == 5) {
		parent.addClass("five-columns");
	}
	if (itemNumber == 4) {
		parent.attr("style", "--columns:1;");
	}
}
function swiperPortfolio() {
	new Swiper(".section-service-detail.section-other-projects .swiper", {
		slidesPerView: 1,
		speed: 1000,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
		modules: [Navigation, Pagination],
		pagination: {
			el: ".section-service-detail.section-other-projects .swiper-pagination",
			dynamicBullets: true,
			dynamicMainBullets: 3,
		},
		navigation: {
			nextEl: ".section-service-detail.section-other-projects .btn-next",
			prevEl: ".section-service-detail.section-other-projects .btn-prev",
		},
	});
}
function swiperServiceNews() {
	new Swiper(".section-service-detail.section-blog .swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		modules: [Navigation, Pagination],
		navigation: {
			nextEl: ".section-service-detail.section-blog .btn-next",
			prevEl: ".section-service-detail.section-blog .btn-prev",
		},
		pagination: {
			el: ".section-service-detail.section-blog .swiper-pagination",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 4,
			},
		},
	});
	new Swiper(".section-service-detail.section-news .swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		modules: [Navigation, Pagination],
		navigation: {
			nextEl: ".section-service-detail.section-news .btn-next",
			prevEl: ".section-service-detail.section-news .btn-prev",
		},
		pagination: {
			el: ".section-service-detail.section-news .swiper-pagination",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 4,
			},
		},
	});
	new Swiper(".section-service-detail.section-our .swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		modules: [Pagination],
		pagination: {
			el: ".section-service-detail.section-our .swiper-pagination",
		},
	});
}
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

/*==================== Load more content ====================*/
// Add this function to initialize the content
function initializeContent() {
	const content = $(".wrap-load-more-content");
	const items = content.children();
	if (items.length > 3) {
		content.css(
			"height",
			items
				.slice(0, 3)
				.toArray()
				.reduce((h, el) => h + $(el).outerHeight(true), 0)
		);
		content.css("overflow", "hidden");
		$(".btn-load-more-content").show();
	} else {
		$(".btn-load-more-content").hide();
	}
}

// Modify the existing click handler
$(".btn-load-more-content").on("click", function (e) {
	e.preventDefault();
	const content = $(".wrap-load-more-content");
	$(this).toggleClass("active");
	if ($(this).hasClass("active")) {
		content.css("height", "auto");
		content.css("overflow", "visible");
		$(this).text("Thu gọn");
	} else {
		initializeContent();
		$(this).text("Xem thêm");
	}
});
